export { onBeforeRenderClient };
import { hydrate } from '@tanstack/vue-query';
const onBeforeRenderClient = (pageContext) => {
    hydrateVueQuery(pageContext);
};
function hydrateVueQuery(pageContext) {
    if (!pageContext.isHydration) {
        return;
    }
    const vueQueryInitialState = pageContext._vueQueryInitialState;
    const queryClient = 'queryClient' in pageContext ? pageContext.queryClient : null;
    if (!queryClient || !vueQueryInitialState) {
        // happens if SSR is off
        return;
    }
    hydrate(queryClient, vueQueryInitialState);
}
